import { Fill, Stroke, Style } from 'ol/style';
import { color as d3color } from 'd3-color';
import color from 'client/utils/constants/GDS/js/color';
import { iconsBaseUrl } from 'client/utils/constants/frontEndConfig';
import { styleRuleToIcon } from 'client/pages/MapPage/components/Legend/Legend.utils';
import { POLYGON } from 'client/utils/constants/geometryType';

const assetOwnerRegionColour = d3color(color.pink);
const assetOwnerRegionHatching = iconsBaseUrl + 'Sensitive_Site_Hatched_Fill_Pink_v3.svg';

const operationalAreaColour = d3color(color['light-blue']);
const operationalAreaHatching = iconsBaseUrl + 'Sensitive_Site_Hatched_Fill_LightBlue_Reverse_v2.svg';

const networkCoverageStyle = (id, feature) => {
    const cnv = document.createElement('canvas');
    const ctx = cnv.getContext('2d');
    const img = new Image();
    img.src = null;
    let customd3Colour;

    if (id === 'assetOwnerRegion') {
        customd3Colour = assetOwnerRegionColour;
        img.src = assetOwnerRegionHatching;
    } else {
        customd3Colour = operationalAreaColour;
        img.src = operationalAreaHatching;
    }
    // Outline of the polygon
    const finishedStroke = new Stroke({
        color: customd3Colour.toString(),
        width: 1.5
    });

    img.onload = function () {
        let fillColor;
        if (id === 'assetOwnerRegion') {
            fillColor = d3color(color.pink);
            fillColor.opacity = 0.4;
        } else {
            fillColor = ctx.createPattern(img, 'repeat');
        }
        feature.setStyle(new Style({
            fill: new Fill({
                color: fillColor
            }),
            stroke: finishedStroke
        }));
    };
};

const assetOwnerRegionStroke = {
    color: 'rgba(213,59,129,255)',
    width: 1
};

const assetOwnerRegionStyle = {
    geometryType: POLYGON,
    fill: {
        color: 'rgba(213, 59, 129, 0.4)'
    },
    stroke: assetOwnerRegionStroke
};

const assetOwnerRegionStyling = styleRuleToIcon(assetOwnerRegionStyle);

const operationalAreaStroke = {
    color: 'rgba(0,154,222,1)',
    width: 1
};

const operationalAreaStyle = {
    geometryType: POLYGON,
    fill: null,
    stroke: operationalAreaStroke,
    imageSource: operationalAreaHatching
};

const operationalAreaStyling = styleRuleToIcon(operationalAreaStyle);

networkCoverageStyle.defaultProps = {
    selected: false
};
export default networkCoverageStyle;
export { networkCoverageStyle, assetOwnerRegionColour, operationalAreaColour, assetOwnerRegionStyling, operationalAreaStyling };
